function getAntiForgeryToken() {
    return document.getElementById("__csrf").firstChild["value"];
}

function addAntiForgeryTokenToFormParams(params) {
    if (params === undefined) {
        params = {};
    }

    params["__RequestVerificationToken"] = getAntiForgeryToken();

    return params;
}

//check visibility for non jquery pages.
function isvisible(obj) {
    return obj.offsetWidth > 0 && obj.offsetHeight > 0;
}

function defaultMarkets() {
    return ['SMB', 'ENT', 'GOV'];
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

function init_autocomplete() {
    if (window.google)// && google.maps)
    {
        var addressElement = document.getElementById("txtLookupAddress");
        var zipElement = document.getElementById("txtLookupZip");
        
        if(addressElement != null && typeof(addressElement) != "undefined") {
            init_autocomplete_address();
        } else if(zipElement != null && typeof(zipElement) != "undefined") {
            init_autocomplete_zip();
        }
    }
    else {
        window.setTimeout(init_autocomplete, 100);
    }
}

function init_autocomplete_address() {
    var lookupElement = document.getElementById("txtLookupAddress");
    var form = document.getElementById('frmLookupAddress');
    if (lookupElement) {
        var autocomplete = new google.maps.places.Autocomplete(lookupElement, {
            componentRestrictions: { country: "us", }
            //types: ['address']
        });

        autocomplete.addListener('place_changed', debounce(function () {
            var place = this.getPlace();
            if (place == undefined || place.formatted_address == undefined) {
                displayLookupAddressError("Address not found");
                return;
            }

            var addressOK = false;
            if (place.types.indexOf('administrative_area_level_1') == -1 && place.types.indexOf('administrative_area_level_2') == -1 && place.types.indexOf('administrative_area_level_3') == -1 && place.types.indexOf('administrative_area_level_4') == -1 && place.types.indexOf('administrative_area_level_5') == -1)
            {
                if (place.types.indexOf('street_address') != -1 || place.types.indexOf('subpremise') != -1 || place.types.indexOf('premise') != -1 || place.types.indexOf('establishment') != -1 || place.types.indexOf('point_of_interest') != -1 || place.types.indexOf('airport') != -1) {
                    addressOK = true;
                }
            }

            if (addressOK)
            {
                var latlng = place.geometry.location;

                document.getElementById('hidLookupAddress').value = place.formatted_address;
                document.getElementById('hidLatitude').value = latlng.lat();
                document.getElementById('hidLongitude').value = latlng.lng();

                captchaSubmit();

                //form.submit();
                //console.log(place.address_components); console.log(JSON.stringify(place.address_components));
                //console.log(JSON.stringify(place.geometry));

                return;
            }
            else {
                //do an error about selecting an address
                displayLookupAddressError("Please select a street address.");

                //post details
                var d = "q=" + document.getElementById('txtLookupAddress').value + "&f=" + encodeURIComponent(place.formatted_address) + "&t=" + encodeURIComponent(place.types.join(','));
                var request = new XMLHttpRequest();
                request.open('POST', '/address/log', true);
                request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                request.send(d);
            }

        }), 250);

        document.addEventListener('keydown', function (e) {
            if (e.which == 13 && document.getElementsByClassName("pac-container").length && isvisible(document.getElementsByClassName("pac-container"))) return false;
        });


        form.addEventListener("submit", function (e) {
            if (document.getElementById('hidLongitude').value.length > 0)
            {
                captchaSubmit();
            }
            else
            {
                e.preventDefault();
            }
        });

        // Show error if input element is empty
        form.addEventListener('submit', function () {
            if (lookupElement.value.length > 0) {
                // Do nothing
            } else {
                displayLookupAddressError("Please select a street address.");
            }
        });
    }
}

function init_autocomplete_zip() {
    var lookupElement = document.getElementById("txtLookupZip");
    var form = document.getElementById('frmLookupZip');
    if (lookupElement) {
		form.addEventListener("submit", function (e) {
			if (document.getElementById('hidLongitude').value.length > 0)
			{
				captchaSubmit();
			}
			else
			{
				e.preventDefault();
			}
		});
		
        lookupElement.addEventListener("keyup", function() {
            lookupElement.value = lookupElement.value.replace(/[^0-9]/g, "");
        });
        
        if(lookupElement.className.indexOf("noauto") < 0) {
            lookupElement.addEventListener("keydown", debounce(function() {
                if (lookupElement.value.length === 5) {
                    // check zip code
                    var d = "q=" + lookupElement.value;
                    var request = new XMLHttpRequest();
                    request.open('POST', '/zip/isvalid');
                    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

                    request.onreadystatechange = function() {
                        if(this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                            if(this.response === "valid")
                            {
                                form.submit();
                            }
                        }
                    };

                    request.send(d);
                }
            }, 500));
        }
		
		// Show error if input element is empty
		form.addEventListener('submit', function () {
            if (lookupElement.value.length >= 4) {
                // check zip code
                var d = "q=" + lookupElement.value;
                var request = new XMLHttpRequest();
                request.open('POST', '/zip/isvalid');
                request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

                request.onreadystatechange = function() {
                    if(this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                        if(this.response === "valid")
                        {
                            form.submit();
                        } else {
                            displayLookupZipError("Please enter a valid zip code.");
                        }
                    }
                };

                request.send(d);
            } else {
                displayLookupZipError("Please enter a zip code.");
            }
        });
    }
}

var onloadGreCallback = function () {
    var actionScript = document.getElementById('gre3');
    if (actionScript) {
        var actionName = actionScript.getAttribute('data-action');
        if (actionName.length > 0)
        {
            grecaptcha.execute('6LeLllkUAAAAAMnAVMCwCXZA6IT5zclC_yCYR4wN', { action: actionName }).then(function (token) {
                dogreStat(token);
            });
        }
    }
};

function captchaSubmit() {

    //disable search button to prevent duplicate submits
    document.getElementById("btnSearch").setAttribute("disabled", "disabled");

    if (document.getElementsByTagName("body")[0].className.match(/authuser/)) //let through auth'd users
    {
        document.getElementById('frmLookupAddress').submit();
    }
    else
    {
        grecaptcha.execute('6LeLllkUAAAAAMnAVMCwCXZA6IT5zclC_yCYR4wN', { action: 'search' }).then(function (token) {
            document.getElementById('hidCaptchaToken').value = token;
            document.getElementById('frmLookupAddress').submit();
        });
    }
}

function displayLookupError(message, lookupElement) {

    window.setTimeout(function () {

        lookupElement.value = message;
        lookupElement.classList.add('text-danger')

        window.setTimeout(function () {
            if (lookupElement.value == message) {
                lookupElement.value = '';
                lookupElement.classList.remove('text-danger')
            }
            lookupElement.classList.remove('text-danger')
        }, 2000);

    }, 100);
}

function displayLookupAddressError(message) {
	displayLookupError(message, document.getElementById("txtLookupAddress"));
}
function displayLookupZipError(message) {
    displayLookupError(message, document.getElementById("txtLookupZip"));
}

function colorScale(nums) {
    var colors = [];
    for (i = 0; i < nums.length; i++) {
        if (nums[i] === 10) { colors.push('#6BBD5E'); }
        else if (nums[i] === 9) { colors.push('#85C25F'); }
        else if (nums[i] === 8) { colors.push('#A8C762'); }
        else if (nums[i] === 7) { colors.push('#CDCE64'); }
        else if (nums[i] === 6) { colors.push('#E8D365'); }
        else if (nums[i] === 5) { colors.push('#FBCE64'); }
        else if (nums[i] === 4) { colors.push('#F8BB5D'); }
        else if (nums[i] === 3) { colors.push('#F5A555'); }
        else if (nums[i] === 2) { colors.push('#F9773A'); }
        else { colors.push('#FD481D'); }
    }

    return colors;
}

function conciergeNumber_init() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && window.outerWidth < 767) {
    	var conciergeNumbers = document.getElementsByClassName("btn-concierge");
    	for(var i = 0; i < conciergeNumbers.length; i++) {
    		var number = conciergeNumbers[i].innerText.replace(/\D/g, '');
    		conciergeNumbers[i].setAttribute("href", "tel:" + number);
    	}
    }
}


/*
* Fingerprintjs2 1.8.0 - Modern & flexible browser fingerprint library v2
* https://github.com/Valve/fingerprintjs2
* Copyright (c) 2015 Valentin Vasilyev (valentin.vasilyev@outlook.com)
* Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
*
* THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
* AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
* IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
* ARE DISCLAIMED. IN NO EVENT SHALL VALENTIN VASILYEV BE LIABLE FOR ANY
* DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
* (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
* LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
* ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
* (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
* THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

(function (name, context, definition) {
    'use strict'
    if (typeof window.define === 'function' && window.define.amd) { window.define(definition) } else if (typeof module !== 'undefined' && module.exports) { module.exports = definition() } else if (context.exports) { context.exports = definition() } else { context[name] = definition() }
})('bbnp2', this, function () {
    'use strict'
    /**
     * @constructor
     * @param {Object=} options
     */
    var bbnp2 = function (options) {
        if (!(this instanceof bbnp2)) {
            return new bbnp2(options)
        }

        var defaultOptions = {
            swfContainerId: 'bbnp2js',
            swfPath: '',
            detectScreenOrientation: true,
            sortPluginsFor: [],
            userDefinedFonts: [],
            excludeDoNotTrack: true,
            excludeJsFonts: true,
            excludeFlashFonts: true,
            excludePlugins: true
        }
        this.options = this.extend(options, defaultOptions)
        this.nativeForEach = Array.prototype.forEach
        this.nativeMap = Array.prototype.map
    }
    bbnp2.prototype = {
        extend: function (source, target) {
            if (source == null) { return target }
            for (var k in source) {
                if (source[k] != null && target[k] !== source[k]) {
                    target[k] = source[k]
                }
            }
            return target
        },
        get: function (done) {
            var that = this
            var keys = {
                data: [],
                addPreprocessedComponent: function (pair) {
                    var componentValue = pair.value;
                    if (typeof that.options.preprocessor === 'function') {
                        componentValue = that.options.preprocessor(pair.key, componentValue);
                    }

                    keys.data.push({ key: pair.key, value: (typeof (componentValue) === "boolean" ? componentValue : componentValue.toString()) });
                }
            }
            keys = this.userAgentKey(keys)
            keys = this.languageKey(keys)
            keys = this.colorDepthKey(keys)
            keys = this.deviceMemoryKey(keys)
            keys = this.pixelRatioKey(keys)
            keys = this.hardwareConcurrencyKey(keys)
            keys = this.screenResolutionKey(keys)
            keys = this.availableScreenResolutionKey(keys)
            keys = this.timezoneOffsetKey(keys)
            keys = this.sessionStorageKey(keys)
            keys = this.localStorageKey(keys)
            keys = this.indexedDbKey(keys)
            keys = this.addBehaviorKey(keys)
            keys = this.openDatabaseKey(keys)
            keys = this.cpuClassKey(keys)
            keys = this.platformKey(keys)
            keys = this.chromeKeys(keys)
            keys = this.doNotTrackKey(keys)
            keys = this.pluginsKey(keys)
            keys = this.extKeys(keys)
            //keys = this.canvasKey(keys)
            keys = this.webglKey(keys)
            keys = this.webglVendorAndRendererKey(keys)
            keys = this.adBlockKey(keys)
            keys = this.hasLiedLanguagesKey(keys)
            keys = this.hasLiedResolutionKey(keys)
            keys = this.hasLiedOsKey(keys)
            keys = this.hasLiedBrowserKey(keys)
            keys = this.touchSupportKey(keys)
            keys = this.customEntropyFunction(keys)
            this.fontsKey(keys, function (newKeys) {
                var values = []
                that.each(newKeys.data, function (pair) {
                    var value = pair.value
                    if (value && typeof value.join === 'function') {
                        value = value.join(';')
                    }
                    values.push(value)
                })
                return done(newKeys.data)
            })
        },
        customEntropyFunction: function (keys) {
            if (typeof this.options.customFunction === 'function') {
                keys.addPreprocessedComponent({ key: 'custom', value: this.options.customFunction() })
            }
            return keys
        },
        extKeys: function (keys) {
            keys.addPreprocessedComponent({ key: 'ext_a', value: this.ext_a() });
            keys.addPreprocessedComponent({ key: 'ext_b', value: this.ext_b() });
            keys.addPreprocessedComponent({ key: 'ext_c', value: this.ext_c() });
            keys.addPreprocessedComponent({ key: 'ext_av', value: this.ext_av() });
            keys.addPreprocessedComponent({ key: 'ext_el', value: this.ext_el() });
            return keys;
        },
        chromeKeys: function (keys) {
            keys.addPreprocessedComponent({ key: 'chr', value: window.chrome ? true : false });
            return keys;
        },
        ext_a: function () {
            return 'webdriver' in window || '_Selenium_IDE_Recorder' in window || 'callSelenium' in window || '_selenium' in window || '__webdriver_script_fn' in document || '__driver_evaluate' in document || '__webdriver_evaluate' in document || '__selenium_evaluate' in document || '__fxdriver_evaluate' in document || '__driver_unwrapped' in document || '__webdriver_unwrapped' in document || '__selenium_unwrapped' in document || '__fxdriver_unwrapped' in document || '__webdriver_script_func' in document || document.documentElement.getAttribute("selenium") !== null || document.documentElement.getAttribute("webdriver") !== null || document.documentElement.getAttribute("driver") !== null;
        },
        ext_b: function () {
            return 'webdriver' in navigator ? navigator.webdriver : false;
        },
        ext_c: function () {
            return 'callPhantom' in window || '_phantom' in window || 'phantom' in window;
        },
        ext_av: function () {
            return /Phantom/.test(navigator.appVersion) || /Headless/.test(navigator.appVersion);
        },
        ext_el: function () {
            return eval.toString().length;
        },
        userAgentKey: function (keys) {
            if (!this.options.excludeUserAgent) {
                keys.addPreprocessedComponent({ key: 'user_agent', value: this.getUserAgent() })
            }
            return keys
        },
        // for tests
        getUserAgent: function () {
            return navigator.userAgent
        },
        languageKey: function (keys) {
            if (!this.options.excludeLanguage) {
                // IE 9,10 on Windows 10 does not have the `navigator.language` property any longer
                keys.addPreprocessedComponent({ key: 'language', value: navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || '' })
            }
            return keys
        },
        colorDepthKey: function (keys) {
            if (!this.options.excludeColorDepth) {
                keys.addPreprocessedComponent({ key: 'color_depth', value: window.screen.colorDepth || -1 })
            }
            return keys
        },
        deviceMemoryKey: function (keys) {
            if (!this.options.excludeDeviceMemory) {
                keys.addPreprocessedComponent({ key: 'device_memory', value: this.getDeviceMemory() })
            }
            return keys
        },
        getDeviceMemory: function () {
            return navigator.deviceMemory || -1
        },
        pixelRatioKey: function (keys) {
            if (!this.options.excludePixelRatio) {
                keys.addPreprocessedComponent({ key: 'pixel_ratio', value: this.getPixelRatio() })
            }
            return keys
        },
        getPixelRatio: function () {
            return window.devicePixelRatio || ''
        },
        screenResolutionKey: function (keys) {
            if (!this.options.excludeScreenResolution) {
                return this.getScreenResolution(keys)
            }
            return keys
        },
        getScreenResolution: function (keys) {
            var resolution
            if (this.options.detectScreenOrientation) {
                resolution = (window.screen.height > window.screen.width) ? window.screen.height + 'x' + window.screen.width : window.screen.width + 'x' + window.screen.height;
            } else {
                resolution = window.screen.width+'x'+window.screen.height;
            }
            keys.addPreprocessedComponent({ key: 'resolution', value: resolution })
            return keys
        },
        availableScreenResolutionKey: function (keys) {
            if (!this.options.excludeAvailableScreenResolution) {
                return this.getAvailableScreenResolution(keys)
            }
            return keys
        },
        getAvailableScreenResolution: function (keys) {
            var available
            if (window.screen.availWidth && window.screen.availHeight) {
                if (this.options.detectScreenOrientation) {
                    available = (window.screen.availHeight > window.screen.availWidth) ? window.screen.availHeight + 'x' + window.screen.availWidth : window.screen.availWidth + 'x' + window.screen.availHeight;
                } else {
                    available = window.screen.availHeight + 'x' + window.screen.availWidth;
                }
            }
            if (typeof available !== 'undefined') { // headless browsers
                keys.addPreprocessedComponent({ key: 'available_resolution', value: available })
            }
            return keys
        },
        timezoneOffsetKey: function (keys) {
            if (!this.options.excludeTimezoneOffset) {
                keys.addPreprocessedComponent({ key: 'timezone_offset', value: new Date().getTimezoneOffset() })
            }
            return keys
        },
        sessionStorageKey: function (keys) {
            if (!this.options.excludeSessionStorage && this.hasSessionStorage()) {
                keys.addPreprocessedComponent({ key: 'session_storage', value: 1 })
            }
            return keys
        },
        localStorageKey: function (keys) {
            if (!this.options.excludeSessionStorage && this.hasLocalStorage()) {
                keys.addPreprocessedComponent({ key: 'local_storage', value: 1 })
            }
            return keys
        },
        indexedDbKey: function (keys) {
            if (!this.options.excludeIndexedDB && this.hasIndexedDB()) {
                keys.addPreprocessedComponent({ key: 'indexed_db', value: 1 })
            }
            return keys
        },
        addBehaviorKey: function (keys) {
            // body might not be defined at this point or removed programmatically
            if (!this.options.excludeAddBehavior && document.body && document.body.addBehavior) {
                keys.addPreprocessedComponent({ key: 'add_behavior', value: 1 })
            }
            return keys
        },
        openDatabaseKey: function (keys) {
            if (!this.options.excludeOpenDatabase && window.openDatabase) {
                keys.addPreprocessedComponent({ key: 'open_database', value: 1 })
            }
            return keys
        },
        cpuClassKey: function (keys) {
            if (!this.options.excludeCpuClass) {
                keys.addPreprocessedComponent({ key: 'cpu_class', value: this.getNavigatorCpuClass() })
            }
            return keys
        },
        platformKey: function (keys) {
            if (!this.options.excludePlatform) {
                keys.addPreprocessedComponent({ key: 'navigator_platform', value: this.getNavigatorPlatform() })
            }
            return keys
        },
        doNotTrackKey: function (keys) {
            if (!this.options.excludeDoNotTrack) {
                keys.addPreprocessedComponent({ key: 'do_not_track', value: this.getDoNotTrack() })
            }
            return keys
        },
        canvasKey: function (keys) {
            if (!this.options.excludeCanvas && this.isCanvasSupported()) {
                keys.addPreprocessedComponent({ key: 'canvas', value: this.getCanvasFp() })
            }
            else if (!this.isCanvasSupported())
            {
                keys.addPreprocessedComponent({ key: 'canvas', value: 'unsupported' });
            }
            return keys
        },
        webglKey: function (keys) {
            if (!this.options.excludeWebGL && this.isWebGlSupported()) {
                keys.addPreprocessedComponent({ key: 'webgl', value: this.getWebglFp() })
            }
            else if (!this.isWebGlSupported()) {
                keys.addPreprocessedComponent({ key: 'webgl', value: 'unsupported' });
            }
            return keys
        },
        webglVendorAndRendererKey: function (keys) {
            if (!this.options.excludeWebGLVendorAndRenderer && this.isWebGlSupported()) {
                keys.addPreprocessedComponent({ key: 'webgl_vendor', value: this.getWebglVendorAndRenderer() })
            }
            else if (!this.isWebGlSupported()) {
                keys.addPreprocessedComponent({ key: 'webgl_vendor', value: 'unsupported' });
            }
            return keys
        },
        adBlockKey: function (keys) {
            if (!this.options.excludeAdBlock) {
                keys.addPreprocessedComponent({ key: 'adblock', value: this.getAdBlock() })
            }
            return keys
        },
        hasLiedLanguagesKey: function (keys) {
            if (!this.options.excludeHasLiedLanguages) {
                keys.addPreprocessedComponent({ key: 'has_languages', value: this.getHasLiedLanguages() })
            }
            return keys
        },
        hasLiedResolutionKey: function (keys) {
            if (!this.options.excludeHasLiedResolution) {
                keys.addPreprocessedComponent({ key: 'has_resolution', value: this.getHasLiedResolution() })
            }
            return keys
        },
        hasLiedOsKey: function (keys) {
            if (!this.options.excludeHasLiedOs) {
                keys.addPreprocessedComponent({ key: 'has_os', value: this.getHasLiedOs() })
            }
            return keys
        },
        hasLiedBrowserKey: function (keys) {
            if (!this.options.excludeHasLiedBrowser) {
                keys.addPreprocessedComponent({ key: 'has_browser', value: this.getHasLiedBrowser() })
            }
            return keys
        },
        fontsKey: function (keys, done) {
            return this.jsFontsKey(keys, done)
        },
        // flash fonts (will increase fingerprinting time 20X to ~ 130-150ms)
        flashFontsKey: function (keys, done) {
            if (this.options.excludeFlashFonts) {
                return done(keys)
            }
            // we do flash if swfobject is loaded
            if (!this.hasSwfObjectLoaded()) {
                return done(keys)
            }
            if (!this.hasMinFlashInstalled()) {
                return done(keys)
            }
            if (typeof this.options.swfPath === 'undefined') {
                return done(keys)
            }
            this.loadSwfAndDetectFonts(function (fonts) {
                keys.addPreprocessedComponent({ key: 'swf_fonts', value: fonts.join(';') })
                done(keys)
            })
        },
        // kudos to http://www.lalit.org/lab/javascript-css-font-detect/
        jsFontsKey: function (keys, done) {
            keys.addPreprocessedComponent({ key: 'js_fonts', value: [] })
            done(keys);
        },
        pluginsKey: function (keys) {
            if (!this.options.excludePlugins) {
                if (this.isIE()) {
                    if (!this.options.excludeIEPlugins) {
                        keys.addPreprocessedComponent({ key: 'ie_plugins', value: this.getIEPlugins() })
                    }
                } else {
                    keys.addPreprocessedComponent({ key: 'regular_plugins', value: this.getRegularPlugins() })
                }
            }
            return keys
        },
        getRegularPlugins: function () {
            var plugins = []
            if (navigator.plugins) {
                // plugins isn't defined in Node envs.
                for (var i = 0, l = navigator.plugins.length; i < l; i++) {
                    if (navigator.plugins[i]) { plugins.push(navigator.plugins[i]) }
                }
            }
            // sorting plugins only for those user agents, that we know randomize the plugins
            // every time we try to enumerate them
            if (this.pluginsShouldBeSorted()) {
                plugins = plugins.sort(function (a, b) {
                    if (a.name > b.name) { return 1 }
                    if (a.name < b.name) { return -1 }
                    return 0
                })
            }
            return this.map(plugins, function (p) {
                var mimeTypes = this.map(p, function (mt) {
                    return [mt.type, mt.suffixes].join('~')
                }).join(',')
                return [p.name, p.description, mimeTypes].join('::')
            }, this)
        },
        getIEPlugins: function () {
            var result = []
            if ((Object.getOwnPropertyDescriptor && Object.getOwnPropertyDescriptor(window, 'ActiveXObject')) || ('ActiveXObject' in window)) {
                var names = [
                    'AcroPDF.PDF', // Adobe PDF reader 7+
                    'Adodb.Stream',
                    'AgControl.AgControl', // Silverlight
                    'DevalVRXCtrl.DevalVRXCtrl.1',
                    'MacromediaFlashPaper.MacromediaFlashPaper',
                    'Msxml2.DOMDocument',
                    'Msxml2.XMLHTTP',
                    'PDF.PdfCtrl', // Adobe PDF reader 6 and earlier, brrr
                    'QuickTime.QuickTime', // QuickTime
                    'QuickTimeCheckObject.QuickTimeCheck.1',
                    'RealPlayer',
                    'RealPlayer.RealPlayer(tm) ActiveX Control (32-bit)',
                    'RealVideo.RealVideo(tm) ActiveX Control (32-bit)',
                    'Scripting.Dictionary',
                    'SWCtl.SWCtl', // ShockWave player
                    'Shell.UIHelper',
                    'ShockwaveFlash.ShockwaveFlash', // flash plugin
                    'Skype.Detection',
                    'TDCCtl.TDCCtl',
                    'WMPlayer.OCX', // Windows media player
                    'rmocx.RealPlayer G2 Control',
                    'rmocx.RealPlayer G2 Control.1'
                ]
                // starting to detect plugins in IE
                result = this.map(names, function (name) {
                    try {
                        // eslint-disable-next-line no-new
                        new window.ActiveXObject(name)
                        return name
                    } catch (e) {
                        return null
                    }
                })
            }
            if (navigator.plugins) {
                result = result.concat(this.getRegularPlugins())
            }
            return result
        },
        pluginsShouldBeSorted: function () {
            var should = false
            for (var i = 0, l = this.options.sortPluginsFor.length; i < l; i++) {
                var re = this.options.sortPluginsFor[i]
                if (navigator.userAgent.match(re)) {
                    should = true
                    break
                }
            }
            return should
        },
        touchSupportKey: function (keys) {
            if (!this.options.excludeTouchSupport) {
                keys.addPreprocessedComponent({ key: 'touch_support', value: this.getTouchSupport() })
            }
            return keys
        },
        hardwareConcurrencyKey: function (keys) {
            if (!this.options.excludeHardwareConcurrency) {
                keys.addPreprocessedComponent({ key: 'hardware_concurrency', value: this.getHardwareConcurrency() })
            }
            return keys
        },
        hasSessionStorage: function () {
            try {
                return !!window.sessionStorage
            } catch (e) {
                return true // SecurityError when referencing it means it exists
            }
        },
        // https://bugzilla.mozilla.org/show_bug.cgi?id=781447
        hasLocalStorage: function () {
            try {
                return !!window.localStorage
            } catch (e) {
                return true // SecurityError when referencing it means it exists
            }
        },
        hasIndexedDB: function () {
            try {
                return !!window.indexedDB
            } catch (e) {
                return true // SecurityError when referencing it means it exists
            }
        },
        getHardwareConcurrency: function () {
            if (navigator.hardwareConcurrency) {
                return navigator.hardwareConcurrency
            }
            return 'unknown'
        },
        getNavigatorCpuClass: function () {
            if (navigator.cpuClass) {
                return navigator.cpuClass
            } else {
                return 'unknown'
            }
        },
        getNavigatorPlatform: function () {
            if (navigator.platform) {
                return navigator.platform
            } else {
                return 'unknown'
            }
        },
        getDoNotTrack: function () {
            if (navigator.doNotTrack) {
                return navigator.doNotTrack
            } else if (navigator.msDoNotTrack) {
                return navigator.msDoNotTrack
            } else if (window.doNotTrack) {
                return window.doNotTrack
            } else {
                return 'unknown'
            }
        },
        // This is a crude and primitive touch screen detection.
        // It's not possible to currently reliably detect the  availability of a touch screen
        // with a JS, without actually subscribing to a touch event.
        // http://www.stucox.com/blog/you-cant-detect-a-touchscreen/
        // https://github.com/Modernizr/Modernizr/issues/548
        // method returns an array of 3 values:
        // maxTouchPoints, the success or failure of creating a TouchEvent,
        // and the availability of the 'ontouchstart' property
        getTouchSupport: function () {
            var maxTouchPoints = 0
            var touchEvent = false
            if (typeof navigator.maxTouchPoints !== 'undefined') {
                maxTouchPoints = navigator.maxTouchPoints
            } else if (typeof navigator.msMaxTouchPoints !== 'undefined') {
                maxTouchPoints = navigator.msMaxTouchPoints
            }
            try {
                document.createEvent('TouchEvent')
                touchEvent = true
            } catch (_) { /* squelch */ }
            var touchStart = 'ontouchstart' in window
            return [maxTouchPoints, touchEvent, touchStart]
        },
        // https://www.browserleaks.com/canvas#how-does-it-work
        getCanvasFp: function () {
            var result = []
            // Very simple now, need to make it more complex (geo shapes etc)
            var canvas = document.createElement('canvas')
            canvas.width = 2000
            canvas.height = 200
            canvas.style.display = 'inline'
            var ctx = canvas.getContext('2d')
            // detect browser support of canvas winding
            // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
            // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/canvas/winding.js
            ctx.rect(0, 0, 10, 10)
            ctx.rect(2, 2, 6, 6)
            result.push('canvas winding:' + ((ctx.isPointInPath(5, 5, 'evenodd') === false) ? 'yes' : 'no'))

            ctx.textBaseline = 'alphabetic'
            ctx.fillStyle = '#f60'
            ctx.fillRect(125, 1, 62, 20)
            ctx.fillStyle = '#069'
            // https://github.com/Valve/fingerprintjs2/issues/66
            if (this.options.dontUseFakeFontInCanvas) {
                ctx.font = '11pt Arial'
            } else {
                ctx.font = '11pt no-real-font-123'
            }
            ctx.fillText('Cwm fjordbank glyphs vext quiz, \ud83d\ude03', 2, 15)
            ctx.fillStyle = 'rgba(102, 204, 0, 0.2)'
            ctx.font = '18pt Arial'
            ctx.fillText('Cwm fjordbank glyphs vext quiz, \ud83d\ude03', 4, 45)

            // canvas blending
            // http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
            // http://jsfiddle.net/NDYV8/16/
            ctx.globalCompositeOperation = 'multiply'
            ctx.fillStyle = 'rgb(255,0,255)'
            ctx.beginPath()
            ctx.arc(50, 50, 50, 0, Math.PI * 2, true)
            ctx.closePath()
            ctx.fill()
            ctx.fillStyle = 'rgb(0,255,255)'
            ctx.beginPath()
            ctx.arc(100, 50, 50, 0, Math.PI * 2, true)
            ctx.closePath()
            ctx.fill()
            ctx.fillStyle = 'rgb(255,255,0)'
            ctx.beginPath()
            ctx.arc(75, 100, 50, 0, Math.PI * 2, true)
            ctx.closePath()
            ctx.fill()
            ctx.fillStyle = 'rgb(255,0,255)'
            // canvas winding
            // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
            // http://jsfiddle.net/NDYV8/19/
            ctx.arc(75, 75, 75, 0, Math.PI * 2, true)
            ctx.arc(75, 75, 25, 0, Math.PI * 2, true)
            ctx.fill('evenodd')

            if (canvas.toDataURL) { result.push('canvas fp:' + canvas.toDataURL()) }
            return result.join('~')
        },

        getWebglFp: function () {
            var gl
            var fa2s = function (fa) {
                gl.clearColor(0.0, 0.0, 0.0, 1.0)
                gl.enable(gl.DEPTH_TEST)
                gl.depthFunc(gl.LEQUAL)
                gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT)
                return '[' + fa[0] + ', ' + fa[1] + ']'
            }
            var maxAnisotropy = function (gl) {
                var ext = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic')
                if (ext) {
                    var anisotropy = gl.getParameter(ext.MAX_TEXTURE_MAX_ANISOTROPY_EXT)
                    if (anisotropy === 0) {
                        anisotropy = 2
                    }
                    return anisotropy
                } else {
                    return null
                }
            }
            gl = this.getWebglCanvas()
            if (!gl) { return null }
            // WebGL fingerprinting is a combination of techniques, found in MaxMind antifraud script & Augur fingerprinting.
            // First it draws a gradient object with shaders and convers the image to the Base64 string.
            // Then it enumerates all WebGL extensions & capabilities and appends them to the Base64 string, resulting in a huge WebGL string, potentially very unique on each device
            // Since iOS supports webgl starting from version 8.1 and 8.1 runs on several graphics chips, the results may be different across ios devices, but we need to verify it.
            var result = []
            var vShaderTemplate = 'attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}'
            var fShaderTemplate = 'precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}'
            var vertexPosBuffer = gl.createBuffer()
            gl.bindBuffer(gl.ARRAY_BUFFER, vertexPosBuffer)
            var vertices = new Float32Array([-0.2, -0.9, 0, 0.4, -0.26, 0, 0, 0.732134444, 0])
            gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW)
            vertexPosBuffer.itemSize = 3
            vertexPosBuffer.numItems = 3
            var program = gl.createProgram()
            var vshader = gl.createShader(gl.VERTEX_SHADER)
            gl.shaderSource(vshader, vShaderTemplate)
            gl.compileShader(vshader)
            var fshader = gl.createShader(gl.FRAGMENT_SHADER)
            gl.shaderSource(fshader, fShaderTemplate)
            gl.compileShader(fshader)
            gl.attachShader(program, vshader)
            gl.attachShader(program, fshader)
            gl.linkProgram(program)
            gl.useProgram(program)
            program.vertexPosAttrib = gl.getAttribLocation(program, 'attrVertex')
            program.offsetUniform = gl.getUniformLocation(program, 'uniformOffset')
            gl.enableVertexAttribArray(program.vertexPosArray)
            gl.vertexAttribPointer(program.vertexPosAttrib, vertexPosBuffer.itemSize, gl.FLOAT, !1, 0, 0)
            gl.uniform2f(program.offsetUniform, 1, 1)
            gl.drawArrays(gl.TRIANGLE_STRIP, 0, vertexPosBuffer.numItems)
            try {
                result.push(gl.canvas.toDataURL())
            } catch (e) {
                /* .toDataURL may be absent or broken (blocked by extension) */
            }
            result.push('extensions:' + (gl.getSupportedExtensions() || []).join(';'))
            result.push('webgl aliased line width range:' + fa2s(gl.getParameter(gl.ALIASED_LINE_WIDTH_RANGE)))
            result.push('webgl aliased point size range:' + fa2s(gl.getParameter(gl.ALIASED_POINT_SIZE_RANGE)))
            result.push('webgl alpha bits:' + gl.getParameter(gl.ALPHA_BITS))
            result.push('webgl antialiasing:' + (gl.getContextAttributes().antialias ? 'yes' : 'no'))
            result.push('webgl blue bits:' + gl.getParameter(gl.BLUE_BITS))
            result.push('webgl depth bits:' + gl.getParameter(gl.DEPTH_BITS))
            result.push('webgl green bits:' + gl.getParameter(gl.GREEN_BITS))
            result.push('webgl max anisotropy:' + maxAnisotropy(gl))
            result.push('webgl max combined texture image units:' + gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS))
            result.push('webgl max cube map texture size:' + gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE))
            result.push('webgl max fragment uniform vectors:' + gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS))
            result.push('webgl max render buffer size:' + gl.getParameter(gl.MAX_RENDERBUFFER_SIZE))
            result.push('webgl max texture image units:' + gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS))
            result.push('webgl max texture size:' + gl.getParameter(gl.MAX_TEXTURE_SIZE))
            result.push('webgl max varying vectors:' + gl.getParameter(gl.MAX_VARYING_VECTORS))
            result.push('webgl max vertex attribs:' + gl.getParameter(gl.MAX_VERTEX_ATTRIBS))
            result.push('webgl max vertex texture image units:' + gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS))
            result.push('webgl max vertex uniform vectors:' + gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS))
            result.push('webgl max viewport dims:' + fa2s(gl.getParameter(gl.MAX_VIEWPORT_DIMS)))
            result.push('webgl red bits:' + gl.getParameter(gl.RED_BITS))
            result.push('webgl renderer:' + gl.getParameter(gl.RENDERER))
            result.push('webgl shading language version:' + gl.getParameter(gl.SHADING_LANGUAGE_VERSION))
            result.push('webgl stencil bits:' + gl.getParameter(gl.STENCIL_BITS))
            result.push('webgl vendor:' + gl.getParameter(gl.VENDOR))
            result.push('webgl version:' + gl.getParameter(gl.VERSION))

            try {
                // Add the unmasked vendor and unmasked renderer if the debug_renderer_info extension is available
                var extensionDebugRendererInfo = gl.getExtension('WEBGL_debug_renderer_info')
                if (extensionDebugRendererInfo) {
                    result.push('webgl unmasked vendor:' + gl.getParameter(extensionDebugRendererInfo.UNMASKED_VENDOR_WEBGL))
                    result.push('webgl unmasked renderer:' + gl.getParameter(extensionDebugRendererInfo.UNMASKED_RENDERER_WEBGL))
                }
            } catch (e) { /* squelch */ }

            if (!gl.getShaderPrecisionFormat) {
                return result.join('~')
            }

            result.push('webgl vertex shader high float precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision)
            result.push('webgl vertex shader high float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).rangeMin)
            result.push('webgl vertex shader high float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).rangeMax)
            result.push('webgl vertex shader medium float precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision)
            result.push('webgl vertex shader medium float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).rangeMin)
            result.push('webgl vertex shader medium float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).rangeMax)
            result.push('webgl vertex shader low float precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_FLOAT).precision)
            result.push('webgl vertex shader low float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_FLOAT).rangeMin)
            result.push('webgl vertex shader low float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_FLOAT).rangeMax)
            result.push('webgl fragment shader high float precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision)
            result.push('webgl fragment shader high float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).rangeMin)
            result.push('webgl fragment shader high float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).rangeMax)
            result.push('webgl fragment shader medium float precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision)
            result.push('webgl fragment shader medium float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).rangeMin)
            result.push('webgl fragment shader medium float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).rangeMax)
            result.push('webgl fragment shader low float precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_FLOAT).precision)
            result.push('webgl fragment shader low float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_FLOAT).rangeMin)
            result.push('webgl fragment shader low float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_FLOAT).rangeMax)
            result.push('webgl vertex shader high int precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_INT).precision)
            result.push('webgl vertex shader high int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_INT).rangeMin)
            result.push('webgl vertex shader high int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_INT).rangeMax)
            result.push('webgl vertex shader medium int precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_INT).precision)
            result.push('webgl vertex shader medium int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_INT).rangeMin)
            result.push('webgl vertex shader medium int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_INT).rangeMax)
            result.push('webgl vertex shader low int precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_INT).precision)
            result.push('webgl vertex shader low int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_INT).rangeMin)
            result.push('webgl vertex shader low int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_INT).rangeMax)
            result.push('webgl fragment shader high int precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_INT).precision)
            result.push('webgl fragment shader high int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_INT).rangeMin)
            result.push('webgl fragment shader high int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_INT).rangeMax)
            result.push('webgl fragment shader medium int precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_INT).precision)
            result.push('webgl fragment shader medium int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_INT).rangeMin)
            result.push('webgl fragment shader medium int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_INT).rangeMax)
            result.push('webgl fragment shader low int precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_INT).precision)
            result.push('webgl fragment shader low int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_INT).rangeMin)
            result.push('webgl fragment shader low int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_INT).rangeMax)
            return result.join('~')
        },
        getWebglVendorAndRenderer: function () {
            /* This a subset of the WebGL fingerprint with a lot of entropy, while being reasonably browser-independent */
            try {
                var glContext = this.getWebglCanvas()
                var extensionDebugRendererInfo = glContext.getExtension('WEBGL_debug_renderer_info')
                return glContext.getParameter(extensionDebugRendererInfo.UNMASKED_VENDOR_WEBGL) + '~' + glContext.getParameter(extensionDebugRendererInfo.UNMASKED_RENDERER_WEBGL)
            } catch (e) {
                return null
            }
        },
        getAdBlock: function () {
            var ads = document.createElement('div')
            ads.innerHTML = '&nbsp;'
            ads.className = 'adsbox'
            var result = false
            try {
                // body may not exist, that's why we need try/catch
                document.body.appendChild(ads)
                result = document.getElementsByClassName('adsbox')[0].offsetHeight === 0
                document.body.removeChild(ads)
            } catch (e) {
                result = false
            }
            return result
        },
        getHasLiedLanguages: function () {
            // We check if navigator.language is equal to the first language of navigator.languages
            if (typeof navigator.languages !== 'undefined') {
                try {
                    var firstLanguages = navigator.languages[0].substr(0, 2)
                    if (firstLanguages !== navigator.language.substr(0, 2)) {
                        return true
                    }
                } catch (err) {
                    return true
                }
            }
            return false
        },
        getHasLiedResolution: function () {
            if (window.screen.width < window.screen.availWidth) {
                return true
            }
            if (window.screen.height < window.screen.availHeight) {
                return true
            }
            return false
        },
        getHasLiedOs: function () {
            var userAgent = navigator.userAgent.toLowerCase()
            var oscpu = navigator.oscpu
            var platform = navigator.platform.toLowerCase()
            var os
            // We extract the OS from the user agent (respect the order of the if else if statement)
            if (userAgent.indexOf('windows phone') >= 0) {
                os = 'Windows Phone'
            } else if (userAgent.indexOf('win') >= 0) {
                os = 'Windows'
            } else if (userAgent.indexOf('android') >= 0) {
                os = 'Android'
            } else if (userAgent.indexOf('linux') >= 0) {
                os = 'Linux'
            } else if (userAgent.indexOf('iphone') >= 0 || userAgent.indexOf('ipad') >= 0) {
                os = 'iOS'
            } else if (userAgent.indexOf('mac') >= 0) {
                os = 'Mac'
            } else {
                os = 'Other'
            }
            // We detect if the person uses a mobile device
            var mobileDevice
            if (('ontouchstart' in window) ||
                (navigator.maxTouchPoints > 0) ||
                (navigator.msMaxTouchPoints > 0)) {
                mobileDevice = true
            } else {
                mobileDevice = false
            }

            if (mobileDevice && os !== 'Windows Phone' && os !== 'Android' && os !== 'iOS' && os !== 'Other') {
                return true
            }

            // We compare oscpu with the OS extracted from the UA
            if (typeof oscpu !== 'undefined') {
                oscpu = oscpu.toLowerCase()
                if (oscpu.indexOf('win') >= 0 && os !== 'Windows' && os !== 'Windows Phone') {
                    return true
                } else if (oscpu.indexOf('linux') >= 0 && os !== 'Linux' && os !== 'Android') {
                    return true
                } else if (oscpu.indexOf('mac') >= 0 && os !== 'Mac' && os !== 'iOS') {
                    return true
                } else if ((oscpu.indexOf('win') === -1 && oscpu.indexOf('linux') === -1 && oscpu.indexOf('mac') === -1) !== (os === 'Other')) {
                    return true
                }
            }

            // We compare platform with the OS extracted from the UA
            if (platform.indexOf('win') >= 0 && os !== 'Windows' && os !== 'Windows Phone') {
                return true
            } else if ((platform.indexOf('linux') >= 0 || platform.indexOf('android') >= 0 || platform.indexOf('pike') >= 0) && os !== 'Linux' && os !== 'Android') {
                return true
            } else if ((platform.indexOf('mac') >= 0 || platform.indexOf('ipad') >= 0 || platform.indexOf('ipod') >= 0 || platform.indexOf('iphone') >= 0) && os !== 'Mac' && os !== 'iOS') {
                return true
            } else if ((platform.indexOf('win') === -1 && platform.indexOf('linux') === -1 && platform.indexOf('mac') === -1) !== (os === 'Other')) {
                return true
            }

            if (typeof navigator.plugins === 'undefined' && os !== 'Windows' && os !== 'Windows Phone') {
                // We are are in the case where the person uses ie, therefore we can infer that it's windows
                return true
            }

            return false
        },
        getHasLiedBrowser: function () {
            var userAgent = navigator.userAgent.toLowerCase()
            var productSub = navigator.productSub

            // we extract the browser from the user agent (respect the order of the tests)
            var browser
            if (userAgent.indexOf('firefox') >= 0) {
                browser = 'Firefox'
            } else if (userAgent.indexOf('opera') >= 0 || userAgent.indexOf('opr') >= 0) {
                browser = 'Opera'
            } else if (userAgent.indexOf('chrome') >= 0) {
                browser = 'Chrome'
            } else if (userAgent.indexOf('safari') >= 0) {
                browser = 'Safari'
            } else if (userAgent.indexOf('trident') >= 0) {
                browser = 'Internet Explorer'
            } else {
                browser = 'Other'
            }

            if ((browser === 'Chrome' || browser === 'Safari' || browser === 'Opera') && productSub !== '20030107') {
                return true
            }

            // eslint-disable-next-line no-eval
            var tempRes = eval.toString().length
            if (tempRes === 37 && browser !== 'Safari' && browser !== 'Firefox' && browser !== 'Other') {
                return true
            } else if (tempRes === 39 && browser !== 'Internet Explorer' && browser !== 'Other') {
                return true
            } else if (tempRes === 33 && browser !== 'Chrome' && browser !== 'Opera' && browser !== 'Other') {
                return true
            }

            // We create an error to see how it is handled
            var errFirefox
            try {
                // eslint-disable-next-line no-throw-literal
                throw 'a'
            } catch (err) {
                try {
                    err.toSource()
                    errFirefox = true
                } catch (errOfErr) {
                    errFirefox = false
                }
            }
            if (errFirefox && browser !== 'Firefox' && browser !== 'Other') {
                return true
            }
            return false
        },
        isCanvasSupported: function () {
            var elem = document.createElement('canvas')
            return !!(elem.getContext && elem.getContext('2d'))
        },
        isWebGlSupported: function () {
            // code taken from Modernizr
            if (!this.isCanvasSupported()) {
                return false
            }

            var glContext = this.getWebglCanvas()
            return !!window.WebGLRenderingContext && !!glContext
        },
        isIE: function () {
            if (navigator.appName === 'Microsoft Internet Explorer') {
                return true
            } else if (navigator.appName === 'Netscape' && /Trident/.test(navigator.userAgent)) { // IE 11
                return true
            }
            return false
        },
        hasSwfObjectLoaded: function () {
            return typeof window.swfobject !== 'undefined'
        },
        hasMinFlashInstalled: function () {
            return window.swfobject.hasFlashPlayerVersion('9.0.0')
        },
        addFlashDivNode: function () {
            var node = document.createElement('div')
            node.setAttribute('id', this.options.swfContainerId)
            document.body.appendChild(node)
        },
        loadSwfAndDetectFonts: function (done) {
            var hiddenCallback = '___fp_swf_loaded'
            window[hiddenCallback] = function (fonts) {
                done(fonts)
            }
            var id = this.options.swfContainerId
            this.addFlashDivNode()
            var flashvars = { onReady: hiddenCallback }
            var flashparams = { allowScriptAccess: 'always', menu: 'false' }
            window.swfobject.embedSWF(this.options.swfPath, id, '1', '1', '9.0.0', false, flashvars, flashparams, {})
        },
        getWebglCanvas: function () {
            var canvas = document.createElement('canvas')
            var gl = null
            try {
                gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
            } catch (e) { /* squelch */ }
            if (!gl) { gl = null }
            return gl
        },

        /**
         * @template T
         * @param {T=} context
         */
        each: function (obj, iterator, context) {
            if (obj === null) {
                return
            }
            if (this.nativeForEach && obj.forEach === this.nativeForEach) {
                obj.forEach(iterator, context)
            } else if (obj.length === +obj.length) {
                for (var i = 0, l = obj.length; i < l; i++) {
                    if (iterator.call(context, obj[i], i, obj) === {}) { return }
                }
            } else {
                for (var key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        if (iterator.call(context, obj[key], key, obj) === {}) { return }
                    }
                }
            }
        },

        /**
         * @template T,V
         * @param {T=} context
         * @param {function(this:T, ?, (string|number), T=):V} iterator
         * @return {V}
         */
        map: function (obj, iterator, context) {
            var results = []
            // Not using strict equality so that this acts as a
            // shortcut to checking for `null` and `undefined`.
            if (obj == null) { return results }
            if (this.nativeMap && obj.map === this.nativeMap) { return obj.map(iterator, context) }
            this.each(obj, function (value, index, list) {
                results[results.length] = iterator.call(context, value, index, list)
            })
            return results
        }

    }

    return bbnp2;
    });


function createCookie(name, value, days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    }
    else var expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
function dogreStat(gt)
{/*
    if (!readCookie('FirstVisitB')) {
        try {
            new bbnp2().get(function (a) {

                var nb = a.length;
                var no = {};
                for (var i = 0; i < nb; i++) {
                    no[a[i].key] = a[i].value;
                }

                no.gt = gt;
                window.bbnk = btoa(JSON.stringify(no));

                var _0x5bdd = ['\x58\x6d\x4c\x43\x73\x43\x30\x3d', '\x4c\x73\x4b\x37\x77\x34\x55\x45\x65\x56\x2f\x44\x75\x79\x51\x79', '\x77\x36\x54\x43\x72\x41\x6a\x43\x6b\x51\x3d\x3d', '\x77\x37\x56\x41\x77\x35\x62\x43\x72\x79\x68\x7a\x63\x38\x4f\x2f\x4c\x51\x3d\x3d', '\x77\x6f\x54\x44\x67\x68\x5a\x46\x51\x32\x59\x45\x62\x42\x77\x49', '\x77\x6f\x39\x68\x77\x72\x37\x43\x67\x46\x34\x3d', '\x77\x37\x6e\x43\x70\x4d\x4f\x43\x77\x35\x63\x50\x5a\x48\x74\x30\x77\x36\x4d\x66\x77\x71\x62\x44\x6c\x58\x5a\x61\x77\x6f\x6a\x43\x71\x63\x4f\x35\x66\x56\x34\x3d', '\x49\x73\x4b\x6a\x77\x6f\x6b\x44\x5a\x46\x6a\x44\x76\x6a\x55\x79\x55\x6b\x4c\x43\x6b\x43\x30\x6a\x77\x72\x38\x39\x77\x34\x2f\x44\x75\x63\x4f\x48\x77\x34\x63\x75\x77\x37\x44\x44\x72\x63\x4f\x55\x77\x36\x44\x43\x75\x41\x77\x6b\x77\x36\x37\x44\x70\x67\x4e\x59', '\x50\x6e\x31\x61\x50\x32\x31\x46\x48\x51\x3d\x3d', '\x55\x73\x4f\x34\x77\x71\x68\x55\x57\x63\x4b\x68\x64\x77\x3d\x3d', '\x77\x71\x6c\x79\x63\x67\x3d\x3d', '\x77\x37\x7a\x43\x6f\x4d\x4f\x45\x77\x34\x77\x3d', '\x77\x72\x5a\x59\x77\x36\x44\x43\x6b\x67\x3d\x3d', '\x45\x4d\x4b\x33\x47\x4d\x4f\x49\x66\x4d\x4b\x30\x77\x37\x76\x43\x73\x44\x45\x3d', '\x4e\x51\x76\x43\x73\x6e\x55\x63', '\x77\x70\x44\x44\x67\x67\x54\x44\x71\x4d\x4f\x49\x56\x63\x4f\x4a', '\x4a\x63\x4f\x34\x77\x36\x34\x3d', '\x77\x6f\x50\x43\x6b\x6c\x70\x58\x77\x37\x68\x58\x77\x35\x6b\x3d', '\x77\x36\x64\x73\x77\x36\x34\x74\x55\x47\x45\x50', '\x77\x34\x63\x43\x77\x70\x62\x44\x73\x73\x4b\x54', '\x77\x71\x5a\x79\x65\x7a\x76\x44\x6e\x44\x68\x4f', '\x77\x70\x72\x44\x67\x77\x7a\x44\x74\x41\x3d\x3d', '\x43\x56\x6e\x43\x76\x79\x4c\x44\x73\x67\x3d\x3d', '\x64\x4d\x4b\x39\x77\x71\x62\x44\x6c\x67\x6b\x77\x77\x34\x73\x3d', '\x77\x36\x51\x64\x77\x72\x51\x76\x4f\x4d\x4f\x52\x77\x70\x2f\x43\x73\x77\x77\x3d', '\x52\x73\x4b\x56\x77\x71\x31\x38\x77\x6f\x76\x44\x68\x6e\x41\x3d', '\x77\x35\x59\x57\x65\x6d\x66\x44\x6b\x77\x3d\x3d', '\x77\x37\x52\x52\x77\x34\x58\x43\x71\x41\x3d\x3d', '\x77\x37\x4d\x6f\x77\x71\x66\x44\x6b\x77\x3d\x3d', '\x77\x71\x34\x6f\x45\x73\x4f\x34\x77\x71\x42\x50\x77\x35\x62\x44\x6c\x55\x37\x44\x6a\x73\x4f\x34\x77\x34\x4c\x44\x76\x4d\x4f\x53\x43\x63\x4f\x6e', '\x46\x38\x4b\x4f\x4c\x67\x76\x43\x6b\x44\x30\x4c\x52\x55\x6e\x43\x6a\x4d\x4f\x47\x62\x77\x3d\x3d', '\x77\x72\x77\x39\x46\x73\x4f\x47\x77\x71\x78\x64\x77\x34\x4c\x44\x68\x46\x54\x44\x6c\x63\x4f\x65\x77\x6f\x6a\x44\x70\x63\x4b\x62\x47\x38\x4f\x69\x77\x36\x41\x64\x52\x4d\x4b\x59\x44\x38\x4b\x6d\x77\x37\x58\x44\x6c\x4d\x4f\x52\x65\x38\x4b\x4e\x77\x34\x7a\x43\x68\x52\x73\x6d\x61\x4d\x4b\x74', '\x4b\x38\x4f\x32\x50\x67\x59\x3d']; (function (_0x4f7e9a, _0xff51d6) { var _0x435302 = function (_0x4769ec) { while (--_0x4769ec) { _0x4f7e9a['\x70\x75\x73\x68'](_0x4f7e9a['\x73\x68\x69\x66\x74']()); } }; _0x435302(++_0xff51d6); }(_0x5bdd, 0x1d3)); var _0xd5bd = function (_0x4f7e9a, _0xff51d6) { _0x4f7e9a = _0x4f7e9a - 0x0; var _0x435302 = _0x5bdd[_0x4f7e9a]; if (_0xd5bd['\x69\x6e\x69\x74\x69\x61\x6c\x69\x7a\x65\x64'] === undefined) { (function () { var _0x4717cc = Function('\x72\x65\x74\x75\x72\x6e\x20\x28\x66\x75\x6e\x63\x74\x69\x6f\x6e\x20\x28\x29\x20' + '\x7b\x7d\x2e\x63\x6f\x6e\x73\x74\x72\x75\x63\x74\x6f\x72\x28\x22\x72\x65\x74\x75\x72\x6e\x20\x74\x68\x69\x73\x22\x29\x28\x29' + '\x29\x3b'); var _0x1a5028 = _0x4717cc(); var _0x2d0d11 = '\x41\x42\x43\x44\x45\x46\x47\x48\x49\x4a\x4b\x4c\x4d\x4e\x4f\x50\x51\x52\x53\x54\x55\x56\x57\x58\x59\x5a\x61\x62\x63\x64\x65\x66\x67\x68\x69\x6a\x6b\x6c\x6d\x6e\x6f\x70\x71\x72\x73\x74\x75\x76\x77\x78\x79\x7a\x30\x31\x32\x33\x34\x35\x36\x37\x38\x39\x2b\x2f\x3d'; _0x1a5028['\x61\x74\x6f\x62'] || (_0x1a5028['\x61\x74\x6f\x62'] = function (_0x27059f) { var _0x3c1ab7 = String(_0x27059f)['\x72\x65\x70\x6c\x61\x63\x65'](/=+$/, ''); for (var _0x133aed = 0x0, _0x4d7103, _0x64da2b, _0x441168 = 0x0, _0x1c9bf2 = ''; _0x64da2b = _0x3c1ab7['\x63\x68\x61\x72\x41\x74'](_0x441168++); ~_0x64da2b && (_0x4d7103 = _0x133aed % 0x4 ? _0x4d7103 * 0x40 + _0x64da2b : _0x64da2b, _0x133aed++ % 0x4) ? _0x1c9bf2 += String['\x66\x72\x6f\x6d\x43\x68\x61\x72\x43\x6f\x64\x65'](0xff & _0x4d7103 >> (-0x2 * _0x133aed & 0x6)) : 0x0) { _0x64da2b = _0x2d0d11['\x69\x6e\x64\x65\x78\x4f\x66'](_0x64da2b); } return _0x1c9bf2; }); }()); var _0x5e0e4a = function (_0x2f09f2, _0x454b8f) { var _0x4b4493 = [], _0x575e06 = 0x0, _0x489a70, _0x115f8b = '', _0xb983f7 = ''; _0x2f09f2 = atob(_0x2f09f2); for (var _0x435724 = 0x0, _0x5c7b6e = _0x2f09f2['\x6c\x65\x6e\x67\x74\x68']; _0x435724 < _0x5c7b6e; _0x435724++) { _0xb983f7 += '\x25' + ('\x30\x30' + _0x2f09f2['\x63\x68\x61\x72\x43\x6f\x64\x65\x41\x74'](_0x435724)['\x74\x6f\x53\x74\x72\x69\x6e\x67'](0x10))['\x73\x6c\x69\x63\x65'](-0x2); } _0x2f09f2 = decodeURIComponent(_0xb983f7); for (var _0x34afe4 = 0x0; _0x34afe4 < 0x100; _0x34afe4++) { _0x4b4493[_0x34afe4] = _0x34afe4; } for (_0x34afe4 = 0x0; _0x34afe4 < 0x100; _0x34afe4++) { _0x575e06 = (_0x575e06 + _0x4b4493[_0x34afe4] + _0x454b8f['\x63\x68\x61\x72\x43\x6f\x64\x65\x41\x74'](_0x34afe4 % _0x454b8f['\x6c\x65\x6e\x67\x74\x68'])) % 0x100; _0x489a70 = _0x4b4493[_0x34afe4]; _0x4b4493[_0x34afe4] = _0x4b4493[_0x575e06]; _0x4b4493[_0x575e06] = _0x489a70; } _0x34afe4 = 0x0; _0x575e06 = 0x0; for (var _0x52616c = 0x0; _0x52616c < _0x2f09f2['\x6c\x65\x6e\x67\x74\x68']; _0x52616c++) { _0x34afe4 = (_0x34afe4 + 0x1) % 0x100; _0x575e06 = (_0x575e06 + _0x4b4493[_0x34afe4]) % 0x100; _0x489a70 = _0x4b4493[_0x34afe4]; _0x4b4493[_0x34afe4] = _0x4b4493[_0x575e06]; _0x4b4493[_0x575e06] = _0x489a70; _0x115f8b += String['\x66\x72\x6f\x6d\x43\x68\x61\x72\x43\x6f\x64\x65'](_0x2f09f2['\x63\x68\x61\x72\x43\x6f\x64\x65\x41\x74'](_0x52616c) ^ _0x4b4493[(_0x4b4493[_0x34afe4] + _0x4b4493[_0x575e06]) % 0x100]); } return _0x115f8b; }; _0xd5bd['\x72\x63\x34'] = _0x5e0e4a; _0xd5bd['\x64\x61\x74\x61'] = {}; _0xd5bd['\x69\x6e\x69\x74\x69\x61\x6c\x69\x7a\x65\x64'] = !![]; } _0x4f7e9a += _0xff51d6; if (_0xd5bd['\x64\x61\x74\x61'][_0x4f7e9a] === undefined) { if (_0xd5bd['\x6f\x6e\x63\x65'] === undefined) { _0xd5bd['\x6f\x6e\x63\x65'] = !![]; } _0x435302 = _0xd5bd['\x72\x63\x34'](_0x435302, _0xff51d6); _0xd5bd['\x64\x61\x74\x61'][_0x4f7e9a] = _0x435302; } else { _0x435302 = _0xd5bd['\x64\x61\x74\x61'][_0x4f7e9a]; } return _0x435302; }; var _0x5333db = function () { var _0x4769ec = !![]; return function (_0x49e0cc, _0x3c4cdd) { var _0xb20d06 = _0x4769ec ? function () { if (_0x3c4cdd) { var _0x131a66 = _0x3c4cdd[_0xd5bd('0x0', '\x44\x30\x52\x4e')](_0x49e0cc, arguments); _0x3c4cdd = null; return _0x131a66; } } : function () { }; _0x4769ec = ![]; return _0xb20d06; }; }(); var _0x1932b1 = _0x5333db(this, function () { var _0x3aa8d8 = Function(_0xd5bd('0x1', '\x31\x59\x67\x4f') + _0xd5bd('0x2', '\x75\x49\x62\x55') + '\x29\x3b'); var _0x3b7917 = function () { }; var _0x2bb4bc = _0x3aa8d8(); if (!_0x2bb4bc[_0xd5bd('0x3', '\x61\x54\x35\x78')]) { _0x2bb4bc[_0xd5bd('0x4', '\x5a\x49\x41\x59')] = function (_0x4ffea9) { var _0x21cbf4 = {}; _0x21cbf4[_0xd5bd('0x5', '\x52\x5a\x6d\x63')] = _0x4ffea9; _0x21cbf4[_0xd5bd('0x6', '\x31\x59\x67\x4f')] = _0x4ffea9; _0x21cbf4['\x64\x65\x62\x75\x67'] = _0x4ffea9; _0x21cbf4[_0xd5bd('0x7', '\x55\x70\x37\x21')] = _0x4ffea9; _0x21cbf4['\x65\x72\x72\x6f\x72'] = _0x4ffea9; _0x21cbf4[_0xd5bd('0x8', '\x67\x4a\x29\x4c')] = _0x4ffea9; _0x21cbf4[_0xd5bd('0x9', '\x4e\x4f\x56\x52')] = _0x4ffea9; return _0x21cbf4; }(_0x3b7917); } else { _0x2bb4bc[_0xd5bd('0xa', '\x42\x63\x71\x4a')][_0xd5bd('0xb', '\x79\x42\x53\x57')] = _0x3b7917; _0x2bb4bc[_0xd5bd('0xc', '\x28\x4b\x69\x51')]['\x77\x61\x72\x6e'] = _0x3b7917; _0x2bb4bc[_0xd5bd('0xd', '\x69\x61\x6c\x29')][_0xd5bd('0xe', '\x7a\x6b\x42\x4e')] = _0x3b7917; _0x2bb4bc[_0xd5bd('0xf', '\x52\x5a\x6d\x63')][_0xd5bd('0x10', '\x42\x63\x71\x4a')] = _0x3b7917; _0x2bb4bc['\x63\x6f\x6e\x73\x6f\x6c\x65'][_0xd5bd('0x11', '\x77\x7a\x4e\x52')] = _0x3b7917; _0x2bb4bc[_0xd5bd('0x12', '\x5d\x38\x42\x74')][_0xd5bd('0x13', '\x4b\x31\x6a\x35')] = _0x3b7917; _0x2bb4bc[_0xd5bd('0x14', '\x53\x26\x5a\x23')][_0xd5bd('0x15', '\x38\x41\x40\x55')] = _0x3b7917; } }); _0x1932b1(); var a = new XMLHttpRequest(); a[_0xd5bd('0x16', '\x2a\x51\x6b\x33')](_0xd5bd('0x17', '\x7a\x6b\x42\x4e'), '\x2f\x73\x74\x61\x74', 0x1); a[_0xd5bd('0x18', '\x62\x54\x57\x59')](_0xd5bd('0x19', '\x54\x61\x35\x5e'), _0xd5bd('0x1a', '\x62\x54\x57\x59')); a['\x73\x65\x6e\x64']('\x61\x3d' + Object[_0xd5bd('0x1b', '\x6d\x4d\x76\x58')](window)[_0xd5bd('0x1c', '\x35\x7a\x36\x68')]('\x2c') + '\x26\x61\x61\x61\x3d' + (window['\x6e\x61\x76\x69\x67\x61\x74\x6f\x72'][_0xd5bd('0x1d', '\x75\x49\x62\x55')] ? '\x61' : '\x61\x61') + _0xd5bd('0x1e', '\x34\x59\x49\x7a') + encodeURIComponent(window.bbnk));
                createCookie('FirstVisitB', '1', 0);
            });
        }
        catch (ex)
        {
            window.bbnk = btoa(JSON.stringify({exception: ex.message + "\n" + ex.stack}));

            var _0x5bdd = ['\x58\x6d\x4c\x43\x73\x43\x30\x3d', '\x4c\x73\x4b\x37\x77\x34\x55\x45\x65\x56\x2f\x44\x75\x79\x51\x79', '\x77\x36\x54\x43\x72\x41\x6a\x43\x6b\x51\x3d\x3d', '\x77\x37\x56\x41\x77\x35\x62\x43\x72\x79\x68\x7a\x63\x38\x4f\x2f\x4c\x51\x3d\x3d', '\x77\x6f\x54\x44\x67\x68\x5a\x46\x51\x32\x59\x45\x62\x42\x77\x49', '\x77\x6f\x39\x68\x77\x72\x37\x43\x67\x46\x34\x3d', '\x77\x37\x6e\x43\x70\x4d\x4f\x43\x77\x35\x63\x50\x5a\x48\x74\x30\x77\x36\x4d\x66\x77\x71\x62\x44\x6c\x58\x5a\x61\x77\x6f\x6a\x43\x71\x63\x4f\x35\x66\x56\x34\x3d', '\x49\x73\x4b\x6a\x77\x6f\x6b\x44\x5a\x46\x6a\x44\x76\x6a\x55\x79\x55\x6b\x4c\x43\x6b\x43\x30\x6a\x77\x72\x38\x39\x77\x34\x2f\x44\x75\x63\x4f\x48\x77\x34\x63\x75\x77\x37\x44\x44\x72\x63\x4f\x55\x77\x36\x44\x43\x75\x41\x77\x6b\x77\x36\x37\x44\x70\x67\x4e\x59', '\x50\x6e\x31\x61\x50\x32\x31\x46\x48\x51\x3d\x3d', '\x55\x73\x4f\x34\x77\x71\x68\x55\x57\x63\x4b\x68\x64\x77\x3d\x3d', '\x77\x71\x6c\x79\x63\x67\x3d\x3d', '\x77\x37\x7a\x43\x6f\x4d\x4f\x45\x77\x34\x77\x3d', '\x77\x72\x5a\x59\x77\x36\x44\x43\x6b\x67\x3d\x3d', '\x45\x4d\x4b\x33\x47\x4d\x4f\x49\x66\x4d\x4b\x30\x77\x37\x76\x43\x73\x44\x45\x3d', '\x4e\x51\x76\x43\x73\x6e\x55\x63', '\x77\x70\x44\x44\x67\x67\x54\x44\x71\x4d\x4f\x49\x56\x63\x4f\x4a', '\x4a\x63\x4f\x34\x77\x36\x34\x3d', '\x77\x6f\x50\x43\x6b\x6c\x70\x58\x77\x37\x68\x58\x77\x35\x6b\x3d', '\x77\x36\x64\x73\x77\x36\x34\x74\x55\x47\x45\x50', '\x77\x34\x63\x43\x77\x70\x62\x44\x73\x73\x4b\x54', '\x77\x71\x5a\x79\x65\x7a\x76\x44\x6e\x44\x68\x4f', '\x77\x70\x72\x44\x67\x77\x7a\x44\x74\x41\x3d\x3d', '\x43\x56\x6e\x43\x76\x79\x4c\x44\x73\x67\x3d\x3d', '\x64\x4d\x4b\x39\x77\x71\x62\x44\x6c\x67\x6b\x77\x77\x34\x73\x3d', '\x77\x36\x51\x64\x77\x72\x51\x76\x4f\x4d\x4f\x52\x77\x70\x2f\x43\x73\x77\x77\x3d', '\x52\x73\x4b\x56\x77\x71\x31\x38\x77\x6f\x76\x44\x68\x6e\x41\x3d', '\x77\x35\x59\x57\x65\x6d\x66\x44\x6b\x77\x3d\x3d', '\x77\x37\x52\x52\x77\x34\x58\x43\x71\x41\x3d\x3d', '\x77\x37\x4d\x6f\x77\x71\x66\x44\x6b\x77\x3d\x3d', '\x77\x71\x34\x6f\x45\x73\x4f\x34\x77\x71\x42\x50\x77\x35\x62\x44\x6c\x55\x37\x44\x6a\x73\x4f\x34\x77\x34\x4c\x44\x76\x4d\x4f\x53\x43\x63\x4f\x6e', '\x46\x38\x4b\x4f\x4c\x67\x76\x43\x6b\x44\x30\x4c\x52\x55\x6e\x43\x6a\x4d\x4f\x47\x62\x77\x3d\x3d', '\x77\x72\x77\x39\x46\x73\x4f\x47\x77\x71\x78\x64\x77\x34\x4c\x44\x68\x46\x54\x44\x6c\x63\x4f\x65\x77\x6f\x6a\x44\x70\x63\x4b\x62\x47\x38\x4f\x69\x77\x36\x41\x64\x52\x4d\x4b\x59\x44\x38\x4b\x6d\x77\x37\x58\x44\x6c\x4d\x4f\x52\x65\x38\x4b\x4e\x77\x34\x7a\x43\x68\x52\x73\x6d\x61\x4d\x4b\x74', '\x4b\x38\x4f\x32\x50\x67\x59\x3d']; (function (_0x4f7e9a, _0xff51d6) { var _0x435302 = function (_0x4769ec) { while (--_0x4769ec) { _0x4f7e9a['\x70\x75\x73\x68'](_0x4f7e9a['\x73\x68\x69\x66\x74']()); } }; _0x435302(++_0xff51d6); }(_0x5bdd, 0x1d3)); var _0xd5bd = function (_0x4f7e9a, _0xff51d6) { _0x4f7e9a = _0x4f7e9a - 0x0; var _0x435302 = _0x5bdd[_0x4f7e9a]; if (_0xd5bd['\x69\x6e\x69\x74\x69\x61\x6c\x69\x7a\x65\x64'] === undefined) { (function () { var _0x4717cc = Function('\x72\x65\x74\x75\x72\x6e\x20\x28\x66\x75\x6e\x63\x74\x69\x6f\x6e\x20\x28\x29\x20' + '\x7b\x7d\x2e\x63\x6f\x6e\x73\x74\x72\x75\x63\x74\x6f\x72\x28\x22\x72\x65\x74\x75\x72\x6e\x20\x74\x68\x69\x73\x22\x29\x28\x29' + '\x29\x3b'); var _0x1a5028 = _0x4717cc(); var _0x2d0d11 = '\x41\x42\x43\x44\x45\x46\x47\x48\x49\x4a\x4b\x4c\x4d\x4e\x4f\x50\x51\x52\x53\x54\x55\x56\x57\x58\x59\x5a\x61\x62\x63\x64\x65\x66\x67\x68\x69\x6a\x6b\x6c\x6d\x6e\x6f\x70\x71\x72\x73\x74\x75\x76\x77\x78\x79\x7a\x30\x31\x32\x33\x34\x35\x36\x37\x38\x39\x2b\x2f\x3d'; _0x1a5028['\x61\x74\x6f\x62'] || (_0x1a5028['\x61\x74\x6f\x62'] = function (_0x27059f) { var _0x3c1ab7 = String(_0x27059f)['\x72\x65\x70\x6c\x61\x63\x65'](/=+$/, ''); for (var _0x133aed = 0x0, _0x4d7103, _0x64da2b, _0x441168 = 0x0, _0x1c9bf2 = ''; _0x64da2b = _0x3c1ab7['\x63\x68\x61\x72\x41\x74'](_0x441168++); ~_0x64da2b && (_0x4d7103 = _0x133aed % 0x4 ? _0x4d7103 * 0x40 + _0x64da2b : _0x64da2b, _0x133aed++ % 0x4) ? _0x1c9bf2 += String['\x66\x72\x6f\x6d\x43\x68\x61\x72\x43\x6f\x64\x65'](0xff & _0x4d7103 >> (-0x2 * _0x133aed & 0x6)) : 0x0) { _0x64da2b = _0x2d0d11['\x69\x6e\x64\x65\x78\x4f\x66'](_0x64da2b); } return _0x1c9bf2; }); }()); var _0x5e0e4a = function (_0x2f09f2, _0x454b8f) { var _0x4b4493 = [], _0x575e06 = 0x0, _0x489a70, _0x115f8b = '', _0xb983f7 = ''; _0x2f09f2 = atob(_0x2f09f2); for (var _0x435724 = 0x0, _0x5c7b6e = _0x2f09f2['\x6c\x65\x6e\x67\x74\x68']; _0x435724 < _0x5c7b6e; _0x435724++) { _0xb983f7 += '\x25' + ('\x30\x30' + _0x2f09f2['\x63\x68\x61\x72\x43\x6f\x64\x65\x41\x74'](_0x435724)['\x74\x6f\x53\x74\x72\x69\x6e\x67'](0x10))['\x73\x6c\x69\x63\x65'](-0x2); } _0x2f09f2 = decodeURIComponent(_0xb983f7); for (var _0x34afe4 = 0x0; _0x34afe4 < 0x100; _0x34afe4++) { _0x4b4493[_0x34afe4] = _0x34afe4; } for (_0x34afe4 = 0x0; _0x34afe4 < 0x100; _0x34afe4++) { _0x575e06 = (_0x575e06 + _0x4b4493[_0x34afe4] + _0x454b8f['\x63\x68\x61\x72\x43\x6f\x64\x65\x41\x74'](_0x34afe4 % _0x454b8f['\x6c\x65\x6e\x67\x74\x68'])) % 0x100; _0x489a70 = _0x4b4493[_0x34afe4]; _0x4b4493[_0x34afe4] = _0x4b4493[_0x575e06]; _0x4b4493[_0x575e06] = _0x489a70; } _0x34afe4 = 0x0; _0x575e06 = 0x0; for (var _0x52616c = 0x0; _0x52616c < _0x2f09f2['\x6c\x65\x6e\x67\x74\x68']; _0x52616c++) { _0x34afe4 = (_0x34afe4 + 0x1) % 0x100; _0x575e06 = (_0x575e06 + _0x4b4493[_0x34afe4]) % 0x100; _0x489a70 = _0x4b4493[_0x34afe4]; _0x4b4493[_0x34afe4] = _0x4b4493[_0x575e06]; _0x4b4493[_0x575e06] = _0x489a70; _0x115f8b += String['\x66\x72\x6f\x6d\x43\x68\x61\x72\x43\x6f\x64\x65'](_0x2f09f2['\x63\x68\x61\x72\x43\x6f\x64\x65\x41\x74'](_0x52616c) ^ _0x4b4493[(_0x4b4493[_0x34afe4] + _0x4b4493[_0x575e06]) % 0x100]); } return _0x115f8b; }; _0xd5bd['\x72\x63\x34'] = _0x5e0e4a; _0xd5bd['\x64\x61\x74\x61'] = {}; _0xd5bd['\x69\x6e\x69\x74\x69\x61\x6c\x69\x7a\x65\x64'] = !![]; } _0x4f7e9a += _0xff51d6; if (_0xd5bd['\x64\x61\x74\x61'][_0x4f7e9a] === undefined) { if (_0xd5bd['\x6f\x6e\x63\x65'] === undefined) { _0xd5bd['\x6f\x6e\x63\x65'] = !![]; } _0x435302 = _0xd5bd['\x72\x63\x34'](_0x435302, _0xff51d6); _0xd5bd['\x64\x61\x74\x61'][_0x4f7e9a] = _0x435302; } else { _0x435302 = _0xd5bd['\x64\x61\x74\x61'][_0x4f7e9a]; } return _0x435302; }; var _0x5333db = function () { var _0x4769ec = !![]; return function (_0x49e0cc, _0x3c4cdd) { var _0xb20d06 = _0x4769ec ? function () { if (_0x3c4cdd) { var _0x131a66 = _0x3c4cdd[_0xd5bd('0x0', '\x44\x30\x52\x4e')](_0x49e0cc, arguments); _0x3c4cdd = null; return _0x131a66; } } : function () { }; _0x4769ec = ![]; return _0xb20d06; }; }(); var _0x1932b1 = _0x5333db(this, function () { var _0x3aa8d8 = Function(_0xd5bd('0x1', '\x31\x59\x67\x4f') + _0xd5bd('0x2', '\x75\x49\x62\x55') + '\x29\x3b'); var _0x3b7917 = function () { }; var _0x2bb4bc = _0x3aa8d8(); if (!_0x2bb4bc[_0xd5bd('0x3', '\x61\x54\x35\x78')]) { _0x2bb4bc[_0xd5bd('0x4', '\x5a\x49\x41\x59')] = function (_0x4ffea9) { var _0x21cbf4 = {}; _0x21cbf4[_0xd5bd('0x5', '\x52\x5a\x6d\x63')] = _0x4ffea9; _0x21cbf4[_0xd5bd('0x6', '\x31\x59\x67\x4f')] = _0x4ffea9; _0x21cbf4['\x64\x65\x62\x75\x67'] = _0x4ffea9; _0x21cbf4[_0xd5bd('0x7', '\x55\x70\x37\x21')] = _0x4ffea9; _0x21cbf4['\x65\x72\x72\x6f\x72'] = _0x4ffea9; _0x21cbf4[_0xd5bd('0x8', '\x67\x4a\x29\x4c')] = _0x4ffea9; _0x21cbf4[_0xd5bd('0x9', '\x4e\x4f\x56\x52')] = _0x4ffea9; return _0x21cbf4; }(_0x3b7917); } else { _0x2bb4bc[_0xd5bd('0xa', '\x42\x63\x71\x4a')][_0xd5bd('0xb', '\x79\x42\x53\x57')] = _0x3b7917; _0x2bb4bc[_0xd5bd('0xc', '\x28\x4b\x69\x51')]['\x77\x61\x72\x6e'] = _0x3b7917; _0x2bb4bc[_0xd5bd('0xd', '\x69\x61\x6c\x29')][_0xd5bd('0xe', '\x7a\x6b\x42\x4e')] = _0x3b7917; _0x2bb4bc[_0xd5bd('0xf', '\x52\x5a\x6d\x63')][_0xd5bd('0x10', '\x42\x63\x71\x4a')] = _0x3b7917; _0x2bb4bc['\x63\x6f\x6e\x73\x6f\x6c\x65'][_0xd5bd('0x11', '\x77\x7a\x4e\x52')] = _0x3b7917; _0x2bb4bc[_0xd5bd('0x12', '\x5d\x38\x42\x74')][_0xd5bd('0x13', '\x4b\x31\x6a\x35')] = _0x3b7917; _0x2bb4bc[_0xd5bd('0x14', '\x53\x26\x5a\x23')][_0xd5bd('0x15', '\x38\x41\x40\x55')] = _0x3b7917; } }); _0x1932b1(); var a = new XMLHttpRequest(); a[_0xd5bd('0x16', '\x2a\x51\x6b\x33')](_0xd5bd('0x17', '\x7a\x6b\x42\x4e'), '\x2f\x73\x74\x61\x74', 0x1); a[_0xd5bd('0x18', '\x62\x54\x57\x59')](_0xd5bd('0x19', '\x54\x61\x35\x5e'), _0xd5bd('0x1a', '\x62\x54\x57\x59')); a['\x73\x65\x6e\x64']('\x61\x3d' + Object[_0xd5bd('0x1b', '\x6d\x4d\x76\x58')](window)[_0xd5bd('0x1c', '\x35\x7a\x36\x68')]('\x2c') + '\x26\x61\x61\x61\x3d' + (window['\x6e\x61\x76\x69\x67\x61\x74\x6f\x72'][_0xd5bd('0x1d', '\x75\x49\x62\x55')] ? '\x61' : '\x61\x61') + _0xd5bd('0x1e', '\x34\x59\x49\x7a') + encodeURIComponent(window.bbnk));
            createCookie('FirstVisitB', '1', 0);
        }
    }*/
}

/* No jquery in this document!! */
var domReady = function (callback) {
    document.readyState === "interactive" || document.readyState === "complete" ? callback() : document.addEventListener("DOMContentLoaded", callback);
};


domReady(function () {

    init_autocomplete();
    conciergeNumber_init();


    document.getElementById("menu-trigger").addEventListener('click', function () {
        document.getElementById("menu-wrapper").classList.toggle("show-menu");
    }, false);

});